module.exports = __webpack_public_path__ + "img/s2.43e9e804.png";